import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-box_top_right_icon",
  "use": "icon-box_top_right_icon-usage",
  "viewBox": "0 0 30.08 30.06",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30.08 30.06\" id=\"icon-box_top_right_icon\"><defs><style>#icon-box_top_right_icon .cls-1{fill:none;stroke:#7ce7fd;stroke-miterlimit:10;stroke-width:3px;}</style></defs><title>右上</title><g id=\"icon-box_top_right_icon_图层_2\" data-name=\"图层 2\"><g id=\"icon-box_top_right_icon_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M0,1.5l18.55.09a10,10,0,0,1,10,10l0,18.47\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol